import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SideNavigationClickService {
    private sideNavigationClickedSubject = new BehaviorSubject<any>(null);
    public sideNavigationClicked$ = this.sideNavigationClickedSubject.asObservable();

    public setSideNavigationClicked(info: any) {
        this.sideNavigationClickedSubject.next(info);
    }
}
